import type { FC, ReactNode } from 'react';
import { InputNumber } from 'antd';
import type { RangeLabels } from '../../../config/tpoGenConfig';

interface RangeInputProps {
    value?: [number | null, number | null];
    onChange?: (value: [number | null, number | null]) => void;
    labels: RangeLabels;
    placeholder: string;
    disabled: boolean;
    unitToggle?: ReactNode;
}

const RangeInput: FC<RangeInputProps> = ({ value, onChange, labels, placeholder, disabled, unitToggle }) => {
    const [first, second] = value ?? [null, null];
    return (
        <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 whitespace-nowrap">{labels.first}</span>
            <InputNumber
                placeholder={placeholder}
                value={first ?? undefined}
                disabled={disabled}
                onChange={(val) => onChange?.([val as number | null, second])}
                style={{ width: '100%', minWidth: 60 }}
            />
            <span className="text-xs text-gray-500 whitespace-nowrap">{labels.second}</span>
            <InputNumber
                placeholder={placeholder}
                value={second ?? undefined}
                disabled={disabled}
                onChange={(val) => onChange?.([first, val as number | null])}
                style={{ width: '100%', minWidth: 60 }}
            />
            {unitToggle && <div className="ml-1">{unitToggle}</div>}
        </div>
    );
};

RangeInput.displayName = 'RangeInput';

export default RangeInput;
